import React from 'react'
import PropTypes from 'prop-types'
import useNearbyPlaces from './useNearbyPlaces'
import Button from 'components/UI/Button'

import './maps-nearby-places.pcss'

const searchRadius = 2000

const MapsNearbyPlaces = ({ center, types, onPlaceSelect, onPlacesChange }) => {
    const [places, loading] = useNearbyPlaces({
        center,
        searchRadius,
        types,
        devDebug: false,
        onPlacesChange,
    })

    return (
        <div className={`maps-nearby-places ${loading ? 'loading' : ''}`}>
            <ul>
                {places.map((place) => {
                    return (
                        <li key={place.place_id}>
                            <Button
                                className="maps-nearby-places__button"
                                onClick={() => onPlaceSelect(place)}
                                trackName="place"
                                trackLabel={place.name}
                            >
                                <span className="maps-nearby-places__button-name">{place.name}</span> <span className="maps-nearby-places__button-vicinity">{place.vicinity}</span>
                            </Button>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}

MapsNearbyPlaces.propTypes = {
    center: PropTypes.object.isRequired,
    types: PropTypes.array.isRequired,
    onPlaceSelect: PropTypes.func.isRequired,
    onPlacesChange: PropTypes.func.isRequired,
}

export default MapsNearbyPlaces
